import * as appActions from './app/actions'
import * as menuBoardsActions from './sugg1144/menuBoards/actions'
import * as establishmentsActions from './sugg1144/establishments/actions'

export default {
    ...appActions,
    ...menuBoardsActions,
    ...establishmentsActions,
}
